/**
 * /settings — placeholder route.
 *
 * Exists so that the Settings link in the dashboard left rail (HD-100) has
 * a real destination instead of being a no-op div. Replaced when a real
 * settings page lands (future ticket).
 */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogoMark } from "../components/LogoMark.js";

export function SettingsPlaceholder() {
  const { t } = useTranslation();
  return (
    <div style={{ minHeight: "100vh", background: "var(--bg, #f0eef6)", display: "grid", placeItems: "center", padding: 24 }}>
      <div style={{ maxWidth: 480, textAlign: "center" }}>
        <LogoMark color="var(--purple, #351DBD)" size={36} />
        <h1 style={{ fontSize: 22, fontWeight: 800, color: "var(--navy, #261F59)", margin: "16px 0 8px", letterSpacing: "-0.02em" }}>
          {t("settings.heading")}
        </h1>
        <p style={{ fontSize: 14, color: "var(--text-muted, #6b7084)", lineHeight: 1.55, margin: 0 }}>
          {t("settings.comingSoon")}
        </p>
        <div style={{ marginTop: 20, display: "flex", gap: 10, justifyContent: "center" }}>
          <Link to="/" className="brand-btn brand-btn-secondary brand-btn-sm">{t("settings.backToDashboard")}</Link>
          <Link to="/account/billing" className="brand-btn brand-btn-primary brand-btn-sm">{t("settings.managePlan")}</Link>
        </div>
      </div>
    </div>
  );
}
